<template>
  <el-dialog :visible.sync="showModal" @close="closeModal()" @close-modal="closeModal()" width="60%">
    <div class="flex items-start justify-between mb-4">
      <div>
        <h2 class="text-2xl font-semibold">Consolidation ID#</h2>
        <div>457906-04</div>
      </div>
      <div>
        <h3 class="text-lg font-semibold">Est. Consolidated cap. (Tonnes)</h3>
        <div>{{ fleetDetails.carriageCapacity }} Tons</div>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-x-3">
      <div>
        <label class="mb-1">Vehicle Type</label>

        <el-select
          v-model="payload.vehicleType"
          placeholder="Select vehicle type"
        >
          <el-option
            v-for="vehicleType in vehicleTypes"
            :key="vehicleType"
            :label="vehicleType"
            :value="vehicleType"
          >
          </el-option>
        </el-select>
      </div>

      <div>
        <label class="mb-1">Select Fleet</label>
        <el-select v-model="payload.fleetId" @change="calculateCapacity()" placeholder="Select fleet">
          <el-option
            v-for="fleet in filterUndispatchedFleet"
            :key="fleet.id"
            :label="fleet.equipment"
            :value="fleet.id"
          >
          </el-option>
        </el-select>
      </div>

      <div style="border: 1px solid #dae8f6; height: 200px">
        <div
          class="pl-4 flex items-center font-semibold"
          style="background: #ecf3fb; height: 60px"
        >
          Origin
        </div>

        <div class="px-4 mt-4">
          {{
            currentLocation
              ? currentLocation.locationName
              : "No Location Selected"
          }},
          <br />
          {{ currentLocation ? currentLocation.address : "" }}
        </div>
      </div>

      <div class="mb-4" style="border: 1px solid #dae8f6; height: 200px">
        <div
          class="pl-4 flex items-center font-semibold"
          style="background: #cef1e8; height: 60px"
        >
          Destination
        </div>

        <div class="px-4 mt-4">
          <label class="mb-1">Destination</label>

          <el-select
            v-model="payload.destination"
            placeholder="Select Destinations"
          >
            <el-option
              v-for="location in locations"
              :key="location.id"
              :label="location.locationName"
              :value="location.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="mt-2">
        <label>Upload Documents</label>
        <div
          :style="{
            height: '48px',
            'background-color': '#FBFCFE',
            border: '1px solid #DAE8F6',
          }"
          class="pt-2 px-3 rounded-lg overflow-hidden flex flex-wrap justify-between"
        >
          <div
            :style="{ color: '#B7BDCD', fontSize: '16px' }"
            class="mt-1 w-9/12"
          >
            <p v-if="!isUploadingDoc && !docUploaded">Upload File</p>
            <div
              v-if="isUploadingDoc"
              class="d-flex justify-content-center py-2 -mt-2"
            >
              <saving-loader :icon-color="'#0253B3'" />
            </div>
            <p v-if="docUploaded" class="w-full">
              <a target="_blank" class="text-blue-700" :href="docurl">{{
                fileName
              }}</a>
            </p>
          </div>

          <button
            @click="triggerUpload = true"
            :style="{
              'background-color': '#CBE0F6',
              height: '32px',
              width: '91px',
            }"
            class="rounded-lg w-3/12"
          >
            Upload
          </button>
        </div>

        <document-upload
          hidden
          ref="documentUploader"
          @input="handleDocUpload($event)"
          @closeTrigger="triggerUpload = false"
          @remove-image="removeImage"
          :docurl="docurl"
          :triggerUpload="triggerUpload"
          :isUploadingImage="isUploadingDoc"
        />
      </div>

      <div class="mt-3">
        <div class="flex flex-no-wrap justify-between">
          <p>Truck Capacity</p>
          <p v-if="fleetDetails != 'N.A'">
            {{ totalWeightTons }}/{{ fleetDetails.carriageCapacity }} Tons
          </p>
        </div>
        <div class="flex flex-row-reverse h-[17px] mt-4">
          <div
            :style="{ 'background-color': '#D5F2EA' }"
            class="w-100 relative z-20 h-6 rounded-r-lg"
          ></div>
          <div
            :style="{
              'background-color': '#00C48C',
              width:
                fleetDetails != 'N.A'
                  ? (totalWeightTons / fleetDetails.carriageCapacity) *
                      100 +
                    '%'
                  : '0%',
            }"
            class="h-6 relative z-10 rounded-l-lg"
          ></div>
        </div>
      </div>
    </div>

    <div class="flex justify-between mt-5" style="height: 40px">
      <button
        class="h-full bg-charcoal text-white rounded font-semibold"
        style="width: 120px"
        @click="reAssignConsolidation('consolidation-completed')"
      >
        Complete
      </button>

      <div class="h-full">
        <button
          class="h-full font-semibold"
          style="width: 120px"
          @click="closeModal()"
        >
          Cancel
        </button>

        <button
          class="h-full bg-primary-yellow rounded font-semibold"
          style="width: 120px"
          @click="reAssignConsolidation('in-progress')"
        >
          Save
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["showModal", "loading", "consolidation"],
  data() {
    return {
      location: { address: "" },
      states: [],
      fleets: [],
      isUploadingDoc: false,
      payload: {
        orgId: "",
        fleetId: null,
        documentUrl: "",
        vehicleType: "",
        destination: "",
        shipments: [],
        userId: "",
      },
      bookings: [],
      vehicleTypes: ["Motorcycle", "Van", "Truck"],
      shippingServices: [],
      consolidationRequest: {
        shippingId: [],
        fleetId: null,
      },
      selectedShippingServiceId: null,
      isLoading: false,
      isFetchingBookings: false,
      selectAll: false,
      selectedShippingIds: [],
      selectedFleetId: null,
      query: "",
      docurl: "",
      actionRowId: null,
     
      state: "",
      showConsolidationDialog: false,
      startDate: null,
      endDate: null,
      newBooking: false,
      sortOrder: "ASC",
      pageNumber: 1,
      pageSize: 10,
      totalBookings: 1,
      sortColumn: "",
      currentTab: "active",
      locations: [],
      triggerUpload: false,
      fileName: "",
      docUploaded: false,
      totalWeightTons : 0
    };
  },
  mounted() {
    this.getAllFleets();
    this.getAllStates();
    this.getAllLocations();

    
  },

  watch: {
    async "payload.fleetId"() {
      if (this.payload.fleetId) {
        const result = this.fleets.find(
          (fleet) => fleet.id === this.payload.fleetId
        );

        if (result) {
          try {
            const { data: response } = await this.$_getSingleLocationDetails(
              result.locationId
            );

            this.location = response.location;
          } catch (err) {
            this.handleError(err);
          }
        }
      }
    },
    "consolidation.shippings"(){
      this.payload.shipments = this.consolidation.shippings.map(x => x.id)
    }
  },

  computed: {
    filterUndispatchedFleet() {
      return this.fleets.filter((f) => f.status != "dispatched");
    },
    unassignedBookings() {
      return this.bookings.filter((booking) => {
        return booking.deliveryStatus == "active" && !booking.consolidationId;
      });
    },
    fleetDetails() {
      if (!this.payload.fleetId) return "N.A";
      return this.fleets.find((fleet) => fleet.id === this.payload.fleetId);
    },
    destinationName() {
      let location = this.locations.find(
        (x) => x.id == this.payload.destination
      );
      return location?.locationName + ", " + location?.state;
    },
    currentLocation() {
      return this.$store.getters.currentLocation;
    },
    organizationId() {
      return this.$store.state.authentication.organizationId;
    },
    userId() {
      return this.$store.state.authentication.userId;
    },
    locationId() {
      return this.$store.getters.currentLocationId;
    },
  },

  methods: {
    async getAllFleets() {
      try {
        const response = await this.$_getAllFleets();

        if (this.locationId) {
          this.fleets = response.data.data.fleet.filter(
            (x) => x.locationId == this.locationId
          );
        } else {
          this.fleets = response.data.data.fleet;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    
    async reAssignConsolidation(status) {
      this.isLoading = true;
      
      this.generateToast(
        "Reassigning consolidations. Please wait...",
        "success"
      );

      try {
        this.payload.orgId = this.organizationId;
        this.payload.userId = this.userId;
        this.payload.id = this.consolidation.id;
        this.payload.origin = this.$store.getters.currentLocationId;
        this.payload.originName =
          this.$store.getters.currentLocation.locationName +
          ", " +
          this.$store.getters.currentLocation.state;
        this.payload.destinationName = this.destinationName;
        this.payload.status = status

        await this.$_modifyConsolidation(this.consolidation.id, this.payload);
        this.isLoading = false;
        this.generateToast("Consolidation Created", "success");
        this.closeModal();
        this.$emit('refetch-consolidation')
        
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleDocUpload(image) {
      this.isUploadingDoc = true;
      this.triggerUpload = false;
      this.fileName = image.name;
      this.docUploaded = false;

      try {
        let response = await this.updateDocument(image);
        this.docurl = response;
        this.payload.documentUrl = response;
        this.isUploadingDoc = false;
        this.docUploaded = true;
        this.generateToast("Document uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingDoc = false;
      }
    },

    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllLocations() {
      try {
        const response = await this.$_getAllLocations();

        this.log(response);
        this.locations = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
    calculateCapacity() {
      let shipmentsBookings = this.consolidation.shippings;
      console.log(this.consolidation)

      if (this.consolidation.shippings.length) {

        let initialWeight = 0;
        let allPackages = shipmentsBookings.map((x) => x.packagees);
        let weights = [];
        allPackages.forEach((x) => {
          weights.push(...x.map((y) => y.estimatedWeight * y.quantity ));
        });

        let totalWeightKg = weights.reduce((pre, next) => pre + next, initialWeight);
        let totalWeightTonsUnFixed = totalWeightKg * 0.001;

        this.totalWeightTons = parseFloat(totalWeightTonsUnFixed.toFixed(4));
      }
    },
    removeImage() {
      this.payload.documentUrl = null;
    },
    closeModal(){
      this.payload = {
        orgId: "",
        fleetId: null,
        documentUrl: "",
        vehicleType: "",
        destination: "",
        shipments: [],
        userId: "",
      }

      this.$emit('close-modal');
      
    }


  },
};
</script>
